export default __webpack_public_path__ + "static/media/Leland.4b3332ec.png";